import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/pages/contact")({
  beforeLoad: () => {
    throw redirect({ to: "/about", statusCode: 301 });
  },
});
